// NotFoundPage.tsx

import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import logoBlack from 'assets/images/logo-light2.png'
import Button from "components/Button/Button";
import { ButtonColor, ButtonSize } from "components/Button/ButtonInterface";
import notFoundLogo from '../../assets/images/not-found.png';



const NotFoundPage: React.FC = () => {
  const partnerInfo = useSelector((state: any) => state.setting.partnerInfo);
  const navigate = useNavigate();

  const handleLogoClick = () => {

      if (partnerInfo?.website) {
        let url = partnerInfo.website;
        // Ensure the URL starts with a protocol
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
          url = `https://${url}`;
        }
        window.open(url, '_blank');
      } else {
        navigate('/');
      }

  };

  return (
    <div className="flex flex-col items-center justify-between  text-center mx-auto px-25" style={{ height: "calc(100vh - 278px)"}}>
      <main className="flex flex-col lap:flex-row items-center justify-center flex-1 gap-16 lap:gap-64 mt-20 lap:mt-0  max-w-mxWidth w-full">
        <div className="text-center lap:text-left">
          {/* <div onClick={handleLogoClick} className=" flex flex-col items-center cursor-pointer">
              {partnerInfo && 
                  <img src={partnerInfo?.resourceURL || logoBlack} className='h-16' alt='' />
              }
              {partnerInfo.name && <h2 className="font-bold mt-4">{partnerInfo.name}</h2>}
          </div> */}

          <h1 className="text-4xl lap:text-6xl font-bold  text-black">Ooops ...</h1>
        
          <h2 className="text-2xl lap:text-4xl font-bold  text-black mt-6 lap:mt-24">Page Not Found</h2>
          <p className="text-lg mb-8 lap:mt-8">
            The page you are looking for could not be found.
          </p>
            
          <div className="mt-8 lap:mt-32">
            <Button text="Go back to Home"  color={ButtonColor.Secondary} size={ButtonSize.Large} onClick={() => {navigate('/')}} />
          </div>
        </div>
        <img src={notFoundLogo} className=" w-180 h-140 lap:w-auto lap:h-auto" alt="404" />

       
      </main>
    </div>
  );
};

export default NotFoundPage;
